const NOOP = () => { };
/**
 * Wrap a React component as an {@link ArtisModule}, so it can be registered with
 * `registerArtisModule` and hosted in a Pane. `init` runs once when the module type is
 * registered. The per-Pane lifecycle (load/show/resize/hide/unload) lives inside the
 * component via the `useModule*` hooks, so the vanilla lifecycle methods are no-ops here.
 *
 * @param component - the React component to render inside each Pane that hosts this module.
 * @param init - optional one-time setup, run when the module type is registered.
 *
 * @example
 * ```tsx
 * function Chart() {
 *   useModuleResize((_slot, { width, height }) => layout(width, height));
 *   return <canvas />;
 * }
 * registerArtisModule("chart", reactArtisModule(Chart));
 * ```
 */
export const reactArtisModule = (component, init) => ({
    init,
    load: NOOP,
    show: NOOP,
    resize: NOOP,
    hide: NOOP,
    unload: NOOP,
    component,
});
/** Narrow an {@link ArtisModule} to a {@link ReactArtisModule} (has a `component`). Used by `<ArtisModuleHost>` to pick its render path. */
export const isReactArtisModule = (module) => typeof module.component === "function";
//# sourceMappingURL=reactArtisModule.js.map